<script>
  import PSPDFKit from "pspdfkit";
  import _ from "lodash";

  import {
    blobToBase64,
    editorToolbarItems,
    getPageVisibleRect,
    exportSelectedImageAsImage,
    exportSelectedInkAsImage,
  } from "./utils.js";

  import CalendarModal from "./component/CalendarModal.svelte";
  import MacroModal from "./component/MacroModal.svelte";
  import SampleDocsModal from "./component/SampleDocsModal.svelte";
  import { Loading } from "carbon-components-svelte";
  import StickerModal from "./component/StickerModal.svelte";
  import StickerAddModal from "./component/StickerAddModal.svelte";
  import {
    onBase64Chunk,
    uploadBase64ToBridge,
  } from "./utils/base64ChunkHandler";
  import { showToast } from "./utils/toastManager.js";
  import { openAlertModal } from "./utils/AlertHelper.js";

  export let arrayBuffers;

  export let readOnly;

  // variable that the parent can bind to for error messages handling
  export let errorMsg = "";
  export let macros = [];
  export let sampleDocs = [];
  export let subDividing;
  export let customFonts;

  export async function funcSubDividing() {
    const newBuffer = await instance.exportPDFWithOperations([
      { type: "keepPages", pageIndexes: [0] },
    ]);
    const oldBuffer = await instance.exportPDFWithOperations([
      { type: "removePages", pageIndexes: [0] },
    ]);
    const newBlob = new Blob([newBuffer], { type: "application/pdf" });
    const oldBlob = new Blob([oldBuffer], { type: "application/pdf" });

    //oldBlob ex) p51 => p50 분철된 파일
    //newBlob ex) p51 => p1 새로운 1페이지 파일

    const oldPDFBase64 = await blobToBase64(oldBlob);
    const newPDFBase64 = await blobToBase64(newBlob);
    const oldPDFBase64DataOnly = oldPDFBase64.replace(
      "data:application/pdf;base64,",
      ""
    );
    const newPDFBase64DataOnly = newPDFBase64.replace(
      "data:application/pdf;base64,",
      ""
    );
    await window.chrome.webview.hostObjects.sync.penChart.subDividing(
      oldPDFBase64DataOnly,
      newPDFBase64DataOnly
    );
    arrayBuffers = newBuffer;
    alert(
      "`분할이 완료 되었습니다.\n분할된 파일은 왼쪽 문서 목록에서 확인할 수 있습니다.`"
    );
    subDividing = false;
  }
  $: {
    if (instance?.totalPageCount > 50 && !readOnly) {
      subDividing = true;
    } else {
      subDividing = false;
    }
  }

  let macroOpen = false;
  let calendarOpen = false;
  let openSampleDoc = false;
  let stickerOpen = false;
  let stickerAddOpen = false;
  let selectedAnnotation;
  let uploading = false;

  let instance;

  function handlePDF(element, arrayBuffers) {
    load(element, arrayBuffers);
    return {
      update(arrayBuffers) {
        unload(element);
        load(element, arrayBuffers);
      },
      destroy() {
        unload(element);
      },
    };
  }

  async function handleMacroSubmit(event) {
    const items = event.detail.items;
    const selectedText = items.map((item) => item.plain_text).join("\n");
    // const countLines = selectedText.split("\n").length;
    const pageRect = getPageVisibleRect(instance);
    const boundingBox = new PSPDFKit.Geometry.Rect({
      left: pageRect.getCenter().x,
      top: pageRect.getCenter().y,
    });
    const annotation = await instance.calculateFittingTextAnnotationBoundingBox(
      new PSPDFKit.Annotations.TextAnnotation({
        pageIndex: instance.viewState.currentPageIndex,
        text: {
          format: "plain",
          value: selectedText,
        },
        horizontalAlign: "left",
        font: "Helvetica",
        boundingBox,
        fontColor: PSPDFKit.Color.RED,
      })
    );

    const createdAnnotation = await instance.create(annotation);

    await instance.setSelectedAnnotation(createdAnnotation[0].id);
    macroOpen = false;
  }

  async function handleCalendarSubmit(event) {
    const date = event.detail.date;

    const pageRect = getPageVisibleRect(instance);
    const boundingBox = new PSPDFKit.Geometry.Rect({
      left: Math.floor(pageRect.getCenter().x),
      top: Math.floor(pageRect.getCenter().y),
    });
    const annotation = await instance.calculateFittingTextAnnotationBoundingBox(
      new PSPDFKit.Annotations.TextAnnotation({
        pageIndex: instance.viewState.currentPageIndex,
        text: {
          format: "plain",
          value: date,
        },
        horizontalAlign: "left",
        font: "Helvetica",
        boundingBox,
        fontColor: PSPDFKit.Color.RED,
      })
    );
    const createdAnnotation = await instance.create(annotation);
    await instance.setSelectedAnnotation(createdAnnotation[0].id);
    calendarOpen = false;
  }
  async function handleSampleDocSubmit(event) {
    const doc = event.detail.doc;
    const fileBase64 =
      await window.chrome.webview.hostObjects.sync.penChart.getSampleDoc(
        doc.id
      );
    if (!fileBase64) {
      return alert("서식 문서가 유효하지 않습니다.");
    }
    const res = await fetch(`data:application/pdf;base64,${fileBase64}`);
    const blob = await res.blob();
    await instance.applyOperations([
      {
        type: "importDocument",
        beforePageIndex: 0,
        document: blob,
        treatImportedDocumentAsOnePage: false,
      },
    ]);
    openSampleDoc = false;
  }
  async function handleStickerImageSubmit(event) {
    if (event.detail) {
      const { blob, width, height, base64 } = event.detail.thumbFile;
      const imageAttachmentId = await instance.createAttachment(blob);
      const pageRect = getPageVisibleRect(instance);
      let widthResize = width;
      let heightResize = height;
      if (width >= pageRect.width) {
        widthResize = pageRect.width / 2;
        heightResize = (widthResize * height) / width;
      }
      const boundingBox = new PSPDFKit.Geometry.Rect({
        height: heightResize,
        width: widthResize,
        left: Math.floor(pageRect.getCenter().x) - pageRect.width / 4,
        top: Math.floor(pageRect.getCenter().y) - pageRect.height / 4,
      });
      const imageAnnotation = new PSPDFKit.Annotations.ImageAnnotation({
        pageIndex: instance.viewState.currentPageIndex,
        imageAttachmentId,
        contentType: "image/png",
        description: "Example",
        boundingBox: boundingBox,
      });
      const createdAnnotation = await instance.create(imageAnnotation);
      await instance.setSelectedAnnotation(createdAnnotation[0].id);
      stickerOpen = false;
      await window.chrome.webview.hostObjects.sync.penChart.putUseCategoryImage(
        event.detail.CategoryId,
        event.detail.Id,
        event.detail.isDefault
      );
    }
  }
  async function handleStickerImageAddSubmit(event) {
    if (!event.detail || !selectedAnnotation) return;

    const jsonStr =
      window.chrome.webview.hostObjects.sync.penChart.GetStickersByCategoryId(
        event.detail.Id
      );
    const images = JSON.parse(jsonStr);
    if (images.length >= 20) {
      openAlertModal({
        width: 400,
        title: "스티커 초과",
        content:
          "카테고리별 20개까지 추가 가능합니다.<br/>필요없는 스티커를 삭제해주세요.",
        submit: function (event) {},
      });
      stickerAddOpen = false;
      selectedAnnotation = null;
      return;
    }

    let result;
    if (selectedAnnotation instanceof PSPDFKit.Annotations.ImageAnnotation) {
      try {
        const imageAttachmentId = selectedAnnotation.imageAttachmentId;
        const arrayBuffer = await instance.getAttachment(imageAttachmentId);
        const blob = new Blob([arrayBuffer], {
          type: selectedAnnotation.contentType,
        });
        const base64WithPrefix = await blobToBase64(blob);
        const base64 = base64WithPrefix.substring(
          base64WithPrefix.indexOf(",") + 1
        );
        result = { base64: base64 };
      } catch (e) {
        console.error("이미지 추출 오류:", e);
        result = null;
      }
    } else if (
      selectedAnnotation instanceof PSPDFKit.Annotations.InkAnnotation
    ) {
      result = await exportSelectedInkAsImage(selectedAnnotation);
    }
    if (result) {
      const { base64 } = result;
      if (!base64) {
        console.error("base64 데이터를 가져올 수 없습니다.");
        stickerAddOpen = false;
        selectedAnnotation = null;
        openAlertModal({
          width: 400,
          title: "오류",
          content: "이미지 데이터를 가져오는 데 실패했습니다.",
          submit: function (event) {},
        });
        return;
      }
      await uploadBase64ToBridge({
        base64String: base64,
        id: event.detail.Id,
        folderName: "Sticker",
        originalFileName: `${selectedAnnotation.id}.png`,
      });
      uploading = true;
    }
  }

  window.onFileSaved = async function (result) {
    console.log(result);
    const jsonStr = JSON.stringify({
      CategoryId: result.id,
      StickerHashPath: result.hashPath,
      StickerUBRSPath: result.ubrsPath,
      ThumbnailHashPath: result.thumbnailHashPath,
      ThumbnailUBRSPath: result.thumbnailUbrsPath,
    });
    console.log(jsonStr);

    const res =
      await window.chrome.webview.hostObjects.sync.penChart.postSticker(
        jsonStr
      );
    showToast({
      title: "스티커",
      subtitle: "추가되었습니다.",
      kind: "success",
    });
    uploading = false;
    stickerAddOpen = false;
    selectedAnnotation = null;
  };

  async function handleSavePdf() {
    try {
      const arrayBuffer = await instance.exportPDF();
      const blob = new Blob([arrayBuffer], { type: "application/pdf" });
      const base64 = await blobToBase64(blob);
      await window.chrome.webview.hostObjects.sync.penChart.startSavePdf();

      let str = base64;
      let maxLength = base64.length;
      let tokenLength = 6000000;
      console.log(maxLength, tokenLength);
      for (let i = 0; i < maxLength; i += tokenLength) {
        await window.chrome.webview.hostObjects.sync.penChart.savingPdf(
          str.slice(i, i + tokenLength)
        );
      }
      await window.chrome.webview.hostObjects.sync.penChart.endSavePdf();
    } catch (error) {
      console.log(error);
    }
  }

  async function handleFontRecovery() {
    try {
      const totalPageCount = instance.totalPageCount;
      for (let pageIndex = 0; pageIndex < totalPageCount; pageIndex++) {
        const pageAnnotations = await instance.getAnnotations(pageIndex);
        for await (const annotation of pageAnnotations) {
          if (annotation instanceof PSPDFKit.Annotations.TextAnnotation) {
            const updatedAnnotation = annotation.set("font", "Helvetica");
            await instance.update(updatedAnnotation);
          }
        }
      }
      return true;
    } catch (e) {
      console.log(e.name);
      console.log(e.message);
      return false;
    }
  }

  async function load(container, arrayBuffers) {
    try {
      const newToolbar = [
        {
          type: "sidebar-thumbnails",
          dropdownGroup: false,
          icon: `/images/penchart/tool/icon_list.svg`,
        },
        { type: "pager", dropdownGroup: false },
        {
          type: "zoom-out",
          dropdownGroup: false,
          icon: `/images/penchart/tool/icon_zoom_out.svg`,
        },
        {
          type: "zoom-in",
          dropdownGroup: false,
          icon: `/images/penchart/tool/icon_zoom_in.svg`,
        },
        { type: "zoom-mode", dropdownGroup: false },
        {
          type: "search",
          dropdownGroup: false,
          icon: `/images/penchart/tool/icon_search.svg`,
        },
        {
          type: "pan",
          dropdownGroup: false,
          icon: `/images/penchart/tool/icon_pager.svg`,
        },

        { type: "spacer", dropdownGroup: false },
        { type: "annotate", dropdownGroup: false },

        {
          type: "ink",
          dropdownGroup: false,
          icon: `/images/penchart/tool/icon_ink.svg`,
        },
        {
          type: "highlighter",
          dropdownGroup: false,
          icon: `/images/penchart/tool/icon_highlighter.svg`,
        },
        {
          type: "ink-eraser",
          dropdownGroup: false,
          icon: `/images/penchart/tool/icon_eraser.svg`,
        },
        {
          type: "custom",
          id: "my-current-date",
          title: "달력",
          icon: `/images/penchart/tool/icon_calendar.svg`,
          selected: false,
          onPress: (e) => {
            calendarOpen = true;
          },
        },
        {
          type: "custom",
          id: "my-file",
          title: "이미지",
          icon: `/images/penchart/tool/icon_image.svg`,
          selected: false,
          onPress: async (e) => {
            try {
              const newFileBase64 =
                await window.chrome.webview.hostObjects.sync.penChart.openFileDialog();
              const response = await fetch(
                `data:image/jpeg;base64,${newFileBase64}`
              ); //.then((response) => response.blob());
              const blob = await response.blob();
              const getHeightAndWidthFromDataUrl = (dataURL) =>
                new Promise((resolve) => {
                  const img = new Image();
                  img.onload = () => {
                    resolve({
                      height: img.height,
                      width: img.width,
                    });
                  };
                  img.src = dataURL;
                });
              const dimensions = await getHeightAndWidthFromDataUrl(
                response.url
              );

              const imageAttachmentId = await instance.createAttachment(blob);
              const pageRect = getPageVisibleRect(instance);
              let widthResize = dimensions.width;
              let heightResize = dimensions.height;
              if (dimensions.width >= pageRect.width) {
                // height resize = (width resize * original height size) / original width size
                widthResize = pageRect.width / 2;
                heightResize =
                  (widthResize * dimensions.height) / dimensions.width;
              }
              const boundingBox = new PSPDFKit.Geometry.Rect({
                height: heightResize,
                width: widthResize,
                left: Math.floor(pageRect.getCenter().x) - pageRect.width / 4,
                top: Math.floor(pageRect.getCenter().y) - pageRect.height / 4,
              });
              const imageAnnotation = new PSPDFKit.Annotations.ImageAnnotation({
                pageIndex: instance.viewState.currentPageIndex,
                imageAttachmentId,
                contentType: "image/png",
                description: "Example",
                boundingBox: boundingBox,
              });
              const createdAnnotation = await instance.create(imageAnnotation);
              await instance.setSelectedAnnotation(createdAnnotation[0].id);
            } catch (error) {
              console.log(error);
            }
          },
        },
        {
          type: "text",
          dropdownGroup: false,
          icon: `/images/penchart/tool/icon_text.svg`,
        },
        {
          type: "custom",
          id: "my-sticker",
          title: "스티커",
          icon: `/images/penchart/tool/icon_sticker.svg`,
          selected: false,
          onPress: async (e) => {
            stickerOpen = !stickerOpen;
          },
        },
        {
          type: "stamp",
          dropdownGroup: false,
          icon: `/images/penchart/tool/icon_stamp.svg`,
        },
        {
          type: "custom",
          id: "my-mecro",
          title: "상용구",
          icon: `/images/penchart/tool/icon_mecro.svg`,
          selected: false,
          onPress: async (e) => {
            macros = [];
            const jsonStr =
              await window.chrome.webview.hostObjects.sync.penChart.getMacros();
            macros = JSON.parse(jsonStr).map((o, i) => {
              o.id = i;
              return o;
            });

            macroOpen = true;
          },
        },
        {
          type: "custom",
          id: "my-font-recovery",
          title: "폰트복원",
          icon: `/images/penchart/tool/font_refresh.svg`,
          selected: false,
          onPress: async () => {
            const result = confirm("폰트를 복원하시겠습니까?");
            if (result) {
              try {
                const success = await handleFontRecovery();
                if (success) {
                  handleSavePdf();
                } else {
                  alert("폰트가 복원 실패했습니다.");
                }
              } catch (error) {
                alert("폰트가 복원 실패했습니다.");
              }
            }
          },
        },
        { type: "spacer", dropdownGroup: false },
        { type: "undo" },
        { type: "redo" },
        { type: "spacer", dropdownGroup: false },
        {
          type: "custom",
          id: "my-custom-button",
          title: "저장",
          icon: `/images/penchart/tool/icon_save.svg`,
          onPress: async (e) => handleSavePdf(),
        },
        { type: "print", dropdownGroup: false },
        {
          type: "document-editor",
          dropdownGroup: false,
          icon: `/images/penchart/tool/icon_add.svg`,
        },
      ];

      const newEditorToolbarItems = editorToolbarItems(
        PSPDFKit.defaultDocumentEditorToolbarItems
      );
      if (!readOnly) {
        const node = document.createElement("span");
        node.style.cssText = `display: flex;height: 44px;align-items: center;justify-content: center;padding: 0 11px;cursor: pointer;`;
        const spanText = document.createElement("span");
        spanText.innerHTML = "페이지 추가";
        const spanSvg = document.createElement("span");
        spanSvg.innerHTML = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false"><path d="M14 3.5H7A1.5 1.5 0 0 0 5.5 5v14A1.5 1.5 0 0 0 7 20.5h10a1.5 1.5 0 0 0 1.5-1.5V8L14 3.5z" fill="currentColor" fill-opacity=".01" stroke="currentColor" stroke-miterlimit="10"></path><path opacity=".66" d="M14.496 8.216h3.514l-4.216-4.217v3.514a.712.712 0 0 0 .702.703z" fill="currentColor"></path><path d="M10.5 13v5m2.5-2.5H8" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"></path></svg>`;
        spanSvg.style.cssText = `flex: 24px 0 0;
          width: 24px;
          height: 24px;
          fill: currentColor;
          justify-content: center;
          display: flex;
          flex-direction: column;margin-right:11px;`;
        node.appendChild(spanSvg);
        node.appendChild(spanText);
        newEditorToolbarItems.unshift({
          id: "custom-new-page-add",
          type: "custom",
          // title: "페이지 추가",
          // icon:`<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false"><path d="M14 3.5H7A1.5 1.5 0 0 0 5.5 5v14A1.5 1.5 0 0 0 7 20.5h10a1.5 1.5 0 0 0 1.5-1.5V8L14 3.5z" fill="currentColor" fill-opacity=".01" stroke="currentColor" stroke-miterlimit="10"></path><path opacity=".66" d="M14.496 8.216h3.514l-4.216-4.217v3.514a.712.712 0 0 0 .702.703z" fill="currentColor"></path><path d="M10.5 13v5m2.5-2.5H8" stroke="currentColor" stroke-miterlimit="10" stroke-linecap="round"></path></svg>`,
          node: node,
          onPress: async () => {
            sampleDocs = [];
            const jsonStr =
              await window.chrome.webview.hostObjects.sync.penChart.getSampleDocs();
            sampleDocs = JSON.parse(jsonStr);
            openSampleDoc = true;
          },
        });
      }
      const initialViewState = new PSPDFKit.ViewState({
        readOnly: readOnly,
      });

      const baseUrl = `${window.location.protocol}//${window.location.host}/build/`;
      const selectNode = document.createElement(`div`);
      selectNode.setAttribute("id", "ic_copy");
      selectNode.style.cssText = `display: none;height: 44px;align-items: center;justify-content: center;padding: 0 11px;cursor: pointer;`;
      selectNode.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
          <g id="Layer_1" clip-path="url(#clip0_1003_14119)">
          <path id="Vector" d="M9.58623 3.1997H1.28869C0.577977 3.1997 0 3.79154 0 4.5193V16.6805C0 17.4083 0.577977 18.0001 1.28869 18.0001H9.58669C10.2974 18.0001 10.8754 17.4083 10.8754 16.6805V4.51883C10.8754 3.79154 10.2974 3.19922 9.58669 3.19922L9.58623 3.1997ZM9.94345 16.6805C9.94345 16.8822 9.78323 17.0463 9.58623 17.0463H1.28869C1.09168 17.0463 0.93147 16.8822 0.93147 16.6805V4.51883C0.93147 4.3171 1.09168 4.15304 1.28869 4.15304H9.58669C9.7837 4.15304 9.94391 4.3171 9.94391 4.51883V16.68L9.94345 16.6805Z" fill="#3D424E"/>
          <path id="Vector_2" d="M12.7112 0H4.41322C3.70298 0 3.125 0.591845 3.125 1.31961V1.67395C3.125 1.93721 3.33365 2.15086 3.59074 2.15086C3.84782 2.15086 4.05647 1.93721 4.05647 1.67395V1.31961C4.05647 1.11788 4.21668 0.953819 4.41322 0.953819H12.7112C12.9082 0.953819 13.0684 1.11788 13.0684 1.31961V13.4808C13.0684 13.6821 12.9082 13.8461 12.7112 13.8461H12.3652C12.1081 13.8461 11.8995 14.0598 11.8995 14.323C11.8995 14.5863 12.1081 14.7999 12.3652 14.7999H12.7112C13.4219 14.7999 13.9999 14.2081 13.9999 13.4808V1.31961C13.9999 0.591845 13.4219 0 12.7112 0Z" fill="#3D424E"/>
          </g>
          <defs>
          <clipPath id="clip0_1003_14119">
          <rect width="14" height="18" fill="white"/>
          </clipPath>
          </defs>
        </svg>
      `;
      selectNode.addEventListener("click", async () => {
        const selectedAnnotation = await instance.getSelectedAnnotation();
        let _selectedAnnotation = _.cloneDeep(selectedAnnotation);
        const pageIndex = instance.viewState.currentPageIndex;
        let copyAnnotation;
        let boundingBox = _.cloneDeep(_selectedAnnotation.boundingBox);
        if (
          _selectedAnnotation instanceof PSPDFKit.Annotations.TextAnnotation
        ) {
          copyAnnotation = new PSPDFKit.Annotations.TextAnnotation({
            pageIndex: pageIndex,
            boundingBox: new PSPDFKit.Geometry.Rect({
              left: boundingBox.left,
              top: boundingBox.top,
              width: boundingBox.width,
              height: boundingBox.height,
            }),
            text: {
              format: "plain",
              value: _selectedAnnotation.text,
            },
            font: _selectedAnnotation.font,
            fontColor: _selectedAnnotation.fontColor,
            fontSize: _selectedAnnotation.fontSize,
            horizontalAlign: _selectedAnnotation.horizontalAlign,
            backgroundColor: _selectedAnnotation.backgroundColor,
            blendMode: _selectedAnnotation.blendMode,
            borderColor: _selectedAnnotation.borderColor,
            borderStyle: _selectedAnnotation.borderStyle,
            borderWidth: _selectedAnnotation.borderWidth,
            opacity: _selectedAnnotation.opacity,
            rotation: _selectedAnnotation.rotation,
          });
        } else if (
          _selectedAnnotation instanceof PSPDFKit.Annotations.ImageAnnotation
        ) {
          copyAnnotation = new PSPDFKit.Annotations.ImageAnnotation({
            pageIndex: pageIndex,
            boundingBox: new PSPDFKit.Geometry.Rect({
              left: boundingBox.left,
              top: boundingBox.top,
              width: boundingBox.width,
              height: boundingBox.height,
            }),
            imageAttachmentId: _selectedAnnotation.imageAttachmentId,
            description: _selectedAnnotation.description,
            contentType: _selectedAnnotation.contentType,
            opacity: _selectedAnnotation.opacity,
            rotation: _selectedAnnotation.rotation,
          });
        } else if (
          _selectedAnnotation instanceof PSPDFKit.Annotations.InkAnnotation
        ) {
          copyAnnotation = new PSPDFKit.Annotations.InkAnnotation({
            pageIndex: pageIndex,
            boundingBox: new PSPDFKit.Geometry.Rect({
              left: boundingBox.left,
              top: boundingBox.top,
              width: boundingBox.width,
              height: boundingBox.height,
            }),
            lineWidth: _selectedAnnotation.lineWidth,
            lines: _selectedAnnotation.lines,
            strokeColor: _selectedAnnotation.strokeColor,
            note: _selectedAnnotation.note,
            backgroundColor: _selectedAnnotation.backgroundColor,
            blendMode: _selectedAnnotation.blendMode,
            borderColor: _selectedAnnotation.borderColor,
            borderStyle: _selectedAnnotation.borderStyle,
            borderWidth: _selectedAnnotation.borderWidth,
            opacity: _selectedAnnotation.opacity,
            rotation: _selectedAnnotation.rotation,
          });
        }
        const [pastedAnnotations] = await instance.create(copyAnnotation);
        await instance.setSelectedAnnotation(pastedAnnotations.id);
        const updatedAnnotation = pastedAnnotations.set(
          "boundingBox",
          new PSPDFKit.Geometry.Rect({
            left: boundingBox.left + 10,
            top: boundingBox.top + 10,
            width: boundingBox.width,
            height: boundingBox.height,
          })
        );
        await instance.update(updatedAnnotation);
      });
      const item = {
        type: "custom",
        id: "my-copy-annotation",
        node: selectNode,
      };
      const loadParams = {
        baseUrl,
        container: container,
        document: arrayBuffers,
        enableHistory: true,
        toolbarItems: readOnly
          ? newToolbar.filter((x) => x.type !== "custom")
          : newToolbar,
        documentEditorToolbarItems: newEditorToolbarItems,
        documentEditorFooterItems:
          PSPDFKit.defaultDocumentEditorFooterItems.filter(
            (item) => item.type !== "save-as" //&& item.type !== "cancel"
          ),
        initialViewState,
        styleSheets: [`/stylesheets/my-pspdfkit-stylesheet.css`],
        disableWebAssemblyStreaming: true,
        enableClipboardActions: true,
        enableHistory: true,
        customFonts: customFonts,
      };
      if (CC_PSPDF_KEY) loadParams.licenseKey = CC_PSPDF_KEY;
      instance = await PSPDFKit.load(loadParams);
      instance.setAnnotationToolbarItems(
        (annotation, { defaultAnnotationToolbarItems }) => {
          if (!annotation) return defaultAnnotationToolbarItems;
          const isActualAnnotation =
            (annotation instanceof PSPDFKit.Annotations.ImageAnnotation ||
              annotation instanceof PSPDFKit.Annotations.InkAnnotation) &&
            annotation.pageIndex != null;
          if (!isActualAnnotation) {
            return defaultAnnotationToolbarItems;
          }

          const customButton = {
            type: "custom",
            id: "add-button-sticker",
            title: "스티커추가",
            icon: `/images/penchart/tool/icon_add_sticker.svg`,
            onPress: () => {
              selectedAnnotation = annotation;
              stickerAddOpen = true;
            },
          };

          const spacerIndex = defaultAnnotationToolbarItems.findIndex(
            (item) => item.type === "spacer"
          );

          const newToolbarItems = [...defaultAnnotationToolbarItems];
          if (spacerIndex !== -1) {
            newToolbarItems.splice(spacerIndex, 0, customButton);
          } else {
            newToolbarItems.push(customButton);
          }

          return newToolbarItems;
        }
      );
      //스템프 추가
      const stampAnnotationTemplates = [];
      for (let i = 0; i < 12; i++) {
        const imageURL = `/images/penchart/${i}.png`;
        const response = await fetch(imageURL); //.then((response) => response.blob());
        const blob = await response.blob();
        const base64 = await blobToBase64(blob);
        const imageAttachmentId = await instance.createAttachment(blob);
        const imageAnnotation = new PSPDFKit.Annotations.ImageAnnotation({
          imageAttachmentId,
          contentType: "image/png",
          description: "Example",
          boundingBox: new PSPDFKit.Geometry.Rect({
            height: 600,
            width: 300,
            top: 0,
            left: 0,
          }),
        });
        stampAnnotationTemplates.push(imageAnnotation);
      }
      await instance.setStampAnnotationTemplates(stampAnnotationTemplates);
      instance.setViewState((viewState) =>
        viewState.set("interactionMode", PSPDFKit.InteractionMode.INK)
      );

      errorMsg = "";
    } catch (error) {
      console.log(error);
      unload(container);
      errorMsg = error.message;
    }
  }

  function unload(container) {
    if (instance) {
      PSPDFKit.unload(instance);
      instance = null;
    } else {
      PSPDFKit.unload(container);
    }
  }
  window.onBase64Chunk = onBase64Chunk;
</script>

<!-- {#each macros as macro (macro.id)}
  <div>
    {JSON.stringify(macro)}
  </div>
{:else}
  <p>없음 ...</p>
{/each} -->

<div use:handlePDF={arrayBuffers} class="container" />

<MacroModal bind:open={macroOpen} bind:macros on:submit={handleMacroSubmit} />
<CalendarModal bind:open={calendarOpen} on:submit={handleCalendarSubmit} />
<SampleDocsModal
  bind:open={openSampleDoc}
  bind:sampleDocs
  on:submit={handleSampleDocSubmit}
/>
<StickerModal bind:open={stickerOpen} on:submit={handleStickerImageSubmit} />

<StickerAddModal
  bind:open={stickerAddOpen}
  on:submit={handleStickerImageAddSubmit}
/>

<div
  id="dochi_context_menu"
  class="custom-context-menu"
  style="display: none;position: absolute;"
>
  <ul>
    <li><a>메뉴1</a></li>
    <li><a>메뉴2</a></li>
  </ul>
</div>

<style>
  .container {
    height: 100%;
  }
  .ic_copy_st {
    display: block;
    width: 44px;
    height: 44px;
    align-items: center;
    background-color: transparent;
    border: 1px solid transparent;
    color: inherit;
    cursor: pointer;
    display: flex;
    font: inherit;
    justify-content: center;
  }
</style>
